export default {
  country_locale: 'hu-HU',
  wia_title: 'Kezdjük a termékkel',
  wia_need_help: 'Termékkategória kiválasztása:',
  wia_model_name: 'A modell neve',
  wia_back: '< változtatás',
  wia_confirm: 'KÜLDÉS',
  wia_issue_title: 'Mi a felmerülő probléma?',
  wia_issue_concern: 'Aggaszt a problémám',
  wia_issue_specific: 'Adja meg a problémát',
  wia_possible_solution: 'Lehetséges megoldások',
  wia_solved_issue: 'Megoldotta a problémát?',
  wia_closed: 'Bezárás X',
  wia_feedback_ok: ' Igen!',
  wia_find_another_solution: 'Keressen másik megoldást',
  wia_feedback_title: 'Örülünk, hogy a probléma megoldódott',
  wia_feedback_text1: 'Látogasson el üzletünkbe az Ön számára készült különleges ajánlatok megismeréséhez',
  wia_feedback_text2: 'Tudjon meg többet legújabb intelligens technológiáinkról',
  wia_smile_up_popup_text1: 'Fedezze fel a védelmi terveket',
  wia_smile_down_popup_title: 'További segítségre van szüksége?',
  wia_smile_down_popup_text1: 'Menjen a második lépéshez',
  wia_smile_down_popup_or_text: 'vagy',
  wia_smile_down_popup_text2: 'Kérjen javítást',
  wia_need_more_help: 'További segítségre van szüksége?',
  wia_optional_label: '(választható)',
  wia_no_solution: 'Sajnos nem találtunk azonnal megoldást a problémájára. Kérjük, kattintson ide a további támogatásért.',
  wia_all_solution: 'Az összes eredmény',
  wia_all_categories: 'Az összes kategória',
  wia_seo_l1_issue: 'Minden hiba kategóriánként',
  wia_seo_wp_country_name: 'Magyarország',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'HU',
  wia_seo_wp_meta_title: 'Problémák és megoldások',
  wia_seo_bk_meta_title: 'Problémák és megoldások',
  wia_seo_hp_meta_title: 'Problémák és megoldások',
  wia_seo_id_meta_title: 'Problémák és megoldások',
  wia_seo_wp_meta_description: '',
  wia_seo_bk_meta_description: '',
  wia_seo_hp_meta_description: '',
  wia_seo_id_meta_description: '',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
